/**
 * FormStep
 */
import React from 'react';
import { NextButton, PreviousButton } from './FormButtons';
var FormStep = function (_a) {
    var step = _a.step, formId = _a.formId, nrOfSteps = _a.nrOfSteps, currentStep = _a.currentStep, children = _a.children, onPrevious = _a.onPrevious;
    var title = step.title, description = step.description, index = step.index;
    var stepId = "form-" + formId + "-step-" + index;
    var isFirstStep = index === 0;
    var isLastStep = index + 2 === nrOfSteps;
    var previousIndex = isFirstStep ? undefined : index - 1;
    var previousId = isFirstStep
        ? undefined
        : "form-" + formId + "-step-" + previousIndex;
    var nextIndex = isLastStep ? undefined : index + 1;
    var nextId = isLastStep ? undefined : "form-" + formId + "-step-" + nextIndex;
    return (React.createElement("section", { id: stepId, key: stepId, "aria-hidden": index !== currentStep, hidden: index !== currentStep },
        title && (React.createElement("header", null,
            React.createElement("h1", { tabIndex: -1 }, title),
            description && React.createElement("p", null, description))),
        children,
        React.createElement("div", null,
            !isFirstStep && (React.createElement(PreviousButton, { isExpanded: currentStep === previousIndex, previousIndex: previousIndex, previousId: previousId, id: formId + "-step-" + index + "-prev-button", onPrevious: onPrevious })),
            !isLastStep && (React.createElement(NextButton, { isExpanded: currentStep === nextIndex, nextId: nextId, id: formId + "-step-" + index + "-next-button" })))));
};
export default FormStep;
